import { Component, OnInit } from '@angular/core';
import { IMyDrpOptions, IMyDateRangeModel } from 'mydaterangepicker';
import { DashboardService} from "../dashboard/services/dashboard.service";
import { Utils} from "../share-modules/Utils";
import { ApiService } from '../services/api.service';


@Component({
  selector: 'app-pdf-selector',
  templateUrl: './pdf-selector.component.html',
  styleUrls: ['./pdf-selector.component.less']
})
export class PdfSelectorComponent implements OnInit {


    openPicker: boolean = false;
    archiveDates:any = [];
    pdf: any;
    myDateRangePickerOptions: IMyDrpOptions = {
        dateFormat: 'dd/mm/yyyy',
        firstDayOfWeek: 'mo',
        sunHighlight: true,
        //height: '34px',
        //width: '260px',
        inline: true,
        alignSelectorRight: false,
        indicateInvalidDateRange: true,
        showClearBtn: false,
        showApplyBtn:false,
        showWeekNumbers: true,
        showSelectDateText:false

        //openSelectorOnInputClick: true,
        //editableDateRangeField: false

    }

    constructor(public dashboardService: DashboardService, public apiService: ApiService) { }

    ngOnInit() {
    }


    // closePicker(){
    //     console.log('blurred');
    //     this.openPicker == false;
    // }

    togglePicker(){
        this.openPicker = !this.openPicker;
    }





    // dateRangeChanged callback function called when the user apply the date range. This is
    // mandatory callback in this option. There are also optional inputFieldChanged and
    // calendarViewChanged callbacks.
    onDateRangeChanged(event: IMyDateRangeModel) {
      //console.log('changed');
        // event properties are: event.beginDate, event.endDate, event.formatted,
        // event.beginEpoc and event.endEpoc
    }



    onDateSelected(event: IMyDateRangeModel){
        let that = this;
        let selectedWeek = Utils.getWeek(event['jsdate']);
        this.pdf = null;

        this.dashboardService.getArchiveReportByDate().subscribe(
            json =>{
                this.archiveDates = json;
            },null,()=>{
                this.archiveDates.forEach(function(element){
                    if(element.week.split('-')[0] == selectedWeek && (event['jsdate'].toString().split(' ')[3] == element.week.split('-')[1])){
                        that.pdf = element.path;
                    }
                });

                if(!this.pdf){
                    alert("No archive exists for the selected week.");
                    return;
                }
                window.open(this.apiService.baseUrl + this.pdf, "_blank");
            }
        );

      this.openPicker = false;
    }




}



// WEBPACK FOOTER //
// ./src/app/pdf-selector/pdf-selector.component.ts